<template>
  <div>
    <v-app>
      <resizable-page>
        <template v-slot:table="tableProps">
          <v-card>
            <v-card-title>
              <div class="md-layout">
                <div class="md-layout-item md-size-50 md-small-size-100">
                  <v-btn
                    color="primary"
                    dark
                    class="ma-2"
                    @click="addReqSP"
                    v-if="role.create"
                  >
                    Add Request
                  </v-btn>
                  <v-menu>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        dark
                        class="ma-2"
                        v-bind="attrs"
                        v-on="on"
                      >
                        Export To XLS
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item link>
                        <downloadExcel
                          :data="dataExport(table)"
                          :fields="field_export"
                          :worksheet="worksheetName"
                          :name="fileName"
                        >
                          All Record
                        </downloadExcel>
                      </v-list-item>
                      <v-list-item link>
                        <downloadExcel
                          :data="exportDisplayedPage"
                          :fields="field_export"
                          :worksheet="worksheetName"
                          :name="fileName"
                        >
                          Displayed record
                        </downloadExcel>
                      </v-list-item>
                      <v-list-item link>
                        <downloadExcel
                          :data="exportAllFitered"
                          :fields="field_export"
                          :worksheet="worksheetName"
                          :name="fileName"
                        >
                          All filtered record
                        </downloadExcel>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
                <div class="md-layout-item md-size-50 md-small-size-100">
                  <div class="d-flex">
                    <v-select
                      style=" max-width: 150px;"
                      :items="option_filter"
                      label="Select"
                      v-model="searchCategory"
                      @change="search = ''"
                      item-text="text"
                      item-value="value"
                      class="ma-2"
                      hide-details
                    >
                    </v-select>
                    <v-text-field
                      :disabled="!searchCategory"
                      v-model="search"
                      label="Search"
                      class="ma-2"
                      single-line
                      hide-details
                    >
                    </v-text-field>
                    <v-btn
                      :disabled="!search"
                      class="mt-5"
                      small
                      color="primary"
                      @click="searchButton"
                    >
                      <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="searchValue"
                      class="mt-5 ml-1"
                      dark
                      small
                      color="red"
                      @click="clearSearchButton"
                      >Clear</v-btn
                    >
                  </div>
                </div>
              </div>
            </v-card-title>
            <v-data-table
              mobile-breakpoint
              :headers="headers"
              :items="table"
              :loading="loadTable"
              loading-text="Loading... Please wait"
              @current-items="getFiltered"
              ref="vTable"
              :height="tableProps.tableHeight"
              fixed-header
              :options.sync="options"
              :server-items-length="totalDataTable"
              :page="page"
              :pageCount="numberOfPages"
              :footer-props="{ 'items-per-page-options': [15, 25, 50] }"
            >
              <template  v-slot:[`item.spare_part_request_warehouse`]="{ item }">
                <span v-if="item.spare_part_request_warehouse">
                {{ item.spare_part_request_warehouse.warehouse_name }}
              </span>
              </template>

              <template v-slot:[`item.spare_part_request_status`]="{ item }">
                {{ item.spare_part_request_status == 0 ? "Registered" : "" }}
                {{
                  item.spare_part_request_status == 1 ? "Request Approved" : ""
                }}
                {{ item.spare_part_request_status == 2 ? "Rejected" : "" }}
                {{ item.spare_part_request_status == 3 ? "Approved" : "" }}
                {{ item.spare_part_request_status == 4 ? "Delivered" : "" }}
                {{ item.spare_part_request_status == 5 ? "Item Received" : "" }}
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      dark
                      x-small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon dark x-small>
                        mdi-format-list-bulleted-square
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-if="role.update"
                      @click="DetailRequest(item.id)"
                    >
                      <v-list-item-title x-small>Detail</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-if="role.update"
                      @click="editRequest(item.id)"
                    >
                      <v-list-item-title x-small>Edit</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
            </v-data-table>
          </v-card>
        </template>
      </resizable-page>
    </v-app>
    <modal ref="modalPrice" class="coba">
      <template v-slot:header>
        <h3>List Price</h3>
      </template>

      <template v-slot:body>
        <list-price-card :data_id="$refs.modalPrice.data" />
      </template>
    </modal>
    <modal ref="modalAddRequestSP">
      <template v-slot:header>
        <div style="text-align:center; margin:auto;">
          <h3>ADD REQUEST SPARE PART</h3>
        </div>
        <md-button
          class="md-icon-button md-dense md-round"
          @click="modalCloseAddRequest()"
        >
          <md-icon>close</md-icon>
        </md-button>
      </template>
      <template v-slot:body>
        <add-req-sp :data_id="$refs.modalAddRequestSP" />
      </template>
    </modal>
    <modal ref="modalDetailRequestSP">
      <template v-slot:header>
        <!-- <div style="text-align:center; margin:auto;">
          <h3>DETAIL REQUEST SPARE PART</h3>
        </div>
        <md-button
          class="md-icon-button md-dense md-round"
          @click="modalCloseDetailRequest()"
        >
          <md-icon>close</md-icon>
        </md-button> -->
      </template>
      <template v-slot:body>
        <detail-req-sp :data_id="$refs.modalDetailRequestSP.data" />
      </template>
    </modal>
    <modal ref="modalEditRequestSP">
      <template v-slot:header>
        <div style="text-align:center; margin:auto;">
          <h3>EDIT REQUEST SPARE PART</h3>
        </div>
        <md-button
          class="md-icon-button md-dense md-round"
          @click="modalCloseEditRequest()"
        >
          <md-icon>close</md-icon>
        </md-button>
      </template>
      <template v-slot:body>
        <edit-req-sp :data_id="$refs.modalEditRequestSP.data" />
      </template>
    </modal>
    <!-- <modal ref="modalAddTfSP">
      <template v-slot:header>
        <div style="text-align:center; margin:auto;">
          <h3>ADD TRANSFER SPARE PART</h3>
        </div>
        <md-button
          class="md-icon-button md-dense md-round"
          @click="modalCloseAddTf()"
        >
          <md-icon>close</md-icon>
        </md-button>
      </template>
      <template v-slot:body>
        <add-tf-sp :data_id="$refs.AddTfSP" />
      </template>
    </modal> -->
  </div>
</template>

<script>
import vuetify from "@/plugins/vuetify";
import Swal from "sweetalert2";
import JsonExcel from "vue-json-excel";
import { Modal } from "@/components";
// import ListPriceCard from "@/pages/Dashboard/Workshop/SparePartMaster/modal/ListPriceCard.vue";
import AddRequestSP from "@/pages/Dashboard/Workshop/SparePartRequest/AddSPRPage.vue";
import EditRequestSP from "@/pages/Dashboard/Workshop/SparePartRequest/EditSPRPage.vue";
import DetailRequestSP from "@/pages/Dashboard/Workshop/SparePartRequest/DetailSPRPage.vue";
// import AddTfSP from "@/pages/Dashboard/Workshop/SparePartMaster/modal/AddTfSPM.vue";
import { ResizablePage } from "@/components";

export default {
  components: {
    downloadExcel: JsonExcel,
    ResizablePage,
    Modal,
    // ListPriceCard,
    "add-req-sp": AddRequestSP,
    "edit-req-sp": EditRequestSP,
    "detail-req-sp": DetailRequestSP,
    // "add-tf-sp": AddTfSP,
  },
  vuetify,
  data() {
    return {
      mounted: true,
      searchValue: null,
      searchCategory: null,
      option_filter: [{ text: "Request No", value: "spare_part_request_no" }],
      page: 1,
      totalDataTable: 0,
      numberOfPages: 0,
      loadTable: false,
      options: {},
      role: "",
      search: "",
      headers: [
        { text: "Actions", value: "actions", align: "center", sortable: false },
        {
          text: "Request NO.",
          align: "start",
          value: "spare_part_request_no",
          width: "200",
        },
        {
          text: "Warehouse",
          value: "spare_part_request_warehouse",
          width: "300",
        },
        {
          text: "Remark",
          value: "spare_part_request_remark",
          width: "300",
        },
        // {
        //   text: "Status",
        //   value: "spare_part_request_status",
        //   width: "150",
        // },
        {
          text: "Created At",
          value: "created_at",
          align: "center",
          width: "200",
        },
      ],
      table: [],
      worksheetName: "Spare Part Request",
      fileName: "Spare Part Request.xls",
      exportDisplayedPage: [],
      exportAllFitered: [],
      field_export: {
        no: "no",
        spare_part_request_warehouse: "spare_part_request_warehouse",
        spare_part_request_remark: "spare_part_request_remark",
        no_item: "no_item",
        spare_part_name: "spare_part_name",
        spare_part_qty: "spare_part_qty",
        spare_part_remark: "spare_part_remark",
        created_at: "created_at",
        updated_at: "updated_at",
      },
    };
  },
  async created() {
    this.role = await this.$store.getters["role_permission/route_filter"];
    this.getList();
    this.mounted = false;
    console.log(this.$refs.modalDetailRequestSP);
  },
  methods: {
    // ambil data yang dibutuhkan
    async getList() {
      this.loadTable = true;
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      console.log(this.options);
      let pageNumber = page;

      let itemsPerPageNumber = itemsPerPage;

      var query = { page: { number: pageNumber, size: itemsPerPageNumber } };

      if (sortBy.length != 0) {
        var sort = sortBy[0];
        if (sortDesc[0]) {
          sort = "-" + sortBy[0];
        }
        query.sort = sort;
      }

      if (this.searchValue && this.searchCategory) {
        if (query.filter) {
          Object.assign(query.filter, {
            [this.searchCategory]: this.searchValue,
          });
        } else {
          query.filter = { [this.searchCategory]: this.searchValue };
        }
      }

      await this.$store.dispatch("workshop_spare_part_request/list", query);

      this.table = await this.$store.getters[
        "workshop_spare_part_request/list"
      ];
      var pageMeta = await this.$store.getters[
        "workshop_spare_part_request/page"
      ];

      console.log(pageMeta);
      this.totalDataTable = pageMeta.total;
      this.numberOfPages = pageMeta["to"];
      this.loadTable = false;
      // console.log(this.table);
    },

    getFiltered(data) {
      this.exportDisplayedPage = this.dataExport(data);
      if (this.$refs.vTable) {
        this.exportAllFitered = this.dataExport(
          this.$refs.vTable.$children[0].filteredItems
        );
      } else {
        this.exportAllFitered = this.dataExport(this.table);
      }
    },

    // format merubah angka ke currency
    formatPrice(value) {
      let val = (value / 1).toFixed().replace(".");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    viewDealerprice(item) {
      this.$refs.modalPrice.openModal({
        id: item.id,
        name:
          "(" +
          item.spare_part_master_code +
          ") " +
          item.spare_part_master_name,
      });
    },

    // fungsi untuk display modal add request spare part
    addReqSP() {
      this.$refs.modalAddRequestSP.openModal();
    },

    modalCloseAddRequest() {
      this.$refs.modalAddRequestSP.closeModal();
      this.getList();
    },

    DetailRequest(id) {
      this.$refs.modalDetailRequestSP.openModal({ id: id });
      this.getList();
    },

    modalCloseDetailRequest() {
      this.$refs.modalDetailRequestSP.closeModal();
      this.getList();
    },

    editRequest(id) {
      this.$refs.modalEditRequestSP.openModal({ id: id });
    },

    modalCloseEditRequest() {
      this.$refs.modalEditRequestSP.closeModal();
      this.getList();
    },

    searchButton() {
      this.searchValue = this.search;
      this.getList();
    },

    clearSearchButton() {
      this.searchValue = null;
      this.search = null;
      this.searchCategory = null;
      this.getList();
    },

    // validasi delete data
    deleteConfirmation(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You wont be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.deleteData(id);
        }
      });
    },

    // fungsi delete
    async deleteData(id) {
      try {
        // kirim data ke api
        await this.$store.dispatch("workshop_spare_part_master/destroy", id);
        // panggil alert success
        await this.$store.dispatch(
          "alerts/success",
          "Spare Part Master data delete successfully."
        );
        //await this.getList();
        var indexOptionTable = this.table.findIndex((p) => p.id == id);
        this.table.splice(indexOptionTable, 1);
      } catch (e) {
        // panggil alert error
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong!"
        );
      }
    },

    //fungsi untuk mengubah data yang siap di export data ke xls, saat dipanggil di awal dan dipanggil berulang kali di fungsi filter
    dataExport(data) {
      // return data.map((v,index) => ({...v, no: index+1}))
      var dataReturn = [];
      data.forEach((value_1, index_1) => {

        if(value_1.spare_part_request_item!=null){
        var spare_part_request_item_length = value_1.spare_part_request_item
          ? value_1.spare_part_request_item.length
          : 0;

        for (let i = 0; i < Math.max(spare_part_request_item_length); i++) {
          var data = {
            no:
              dataReturn[index_1] && dataReturn[index_1].no == index_1 + 1
                ? null
                : index_1 + 1,
            spare_part_request_warehouse:
              value_1.spare_part_request_warehouse.warehouse_name,
            spare_part_request_remark: value_1.spare_part_request_remark,
            no_item: value_1.spare_part_request_item[i] ? i + 1 : null,
            spare_part_name: value_1.spare_part_request_item[i]
              ? value_1.spare_part_request_item[i].spare_part.spare_part_master_name
              : null,
            spare_part_qty: value_1.spare_part_request_item[i]
              ? value_1.spare_part_request_item[i].spare_part_request_item_qty
              : null,
            spare_part_remark: value_1.spare_part_request_item[i]
              ? value_1.spare_part_request_item[i]
                  .spare_part_request_item_remark
              : null,
            created_at: value_1.created_at,
            updated_at: value_1.created_at,
          };
          dataReturn.push(data);
        }
      }
      });
      return dataReturn;
    },
  },
};
</script>
<style lang="scss" scoped>
.v-application--wrap {
  min-height: unset;
}
.v-list-item__title {
  font-size: 0.8rem;
}

.coba {
  width: 800px !important;
  margin: 50px auto !important;

  @media screen and (max-width: 992px) {
    width: 90% !important;
  }
}
</style>
